import { Component } from '@verndale/core';
import Masonry from 'masonry-layout';
import CardV2 from '../components/CardV2';

class Module extends Component {
  setupDefaults() {
    this.dom = { insightCards: this.el.querySelectorAll('.insight-card-v2') };
    const cards = [];
    this.dom.insightCards.forEach(card => cards.push(new CardV2(card)));
    this.initMasonry();
  }

  addListeners() {}

  initMasonry() {
    new Masonry(this.el, {
      itemSelector: '.insight-card-v2',
      gutter: '.gutter-sizer',
      columnWidth: '.grid-sizer',
      percentPosition: true
    });
  }
}

export default Module;
